(function () {
  const SELECTOR = '[data-diggn-product-story]';
  const DESKTOP_QUERY = '(min-width: 990px)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initialiseStory(story) {
    if (story.dataset.storyReady === 'true') return;

    const chapters = Array.from(story.querySelectorAll('[data-story-chapter]'));
    const visuals = Array.from(story.querySelectorAll('[data-story-visual]'));
    const counter = story.querySelector('[data-story-counter]');
    const returnLink = story.querySelector('[data-story-return]');
    if (!chapters.length || chapters.length !== visuals.length) return;

    const reviews = document.querySelector('#diggn-product-reviews.diggn-reviews');
    const storySection = story.closest('.shopify-section');
    if (reviews && storySection && storySection.nextElementSibling !== reviews) {
      storySection.insertAdjacentElement('afterend', reviews);
    }

    let activeIndex = 0;
    let frameRequested = false;

    function setActive(index) {
      const nextIndex = clamp(index, 0, chapters.length - 1);
      if (nextIndex === activeIndex && story.dataset.storyInitialised === 'true') return;

      activeIndex = nextIndex;
      chapters.forEach((chapter, chapterIndex) => chapter.classList.toggle('is-active', chapterIndex === activeIndex));
      visuals.forEach((visual, visualIndex) => visual.classList.toggle('is-active', visualIndex === activeIndex));
      story.style.setProperty('--story-active-index', String(activeIndex));
      if (counter) counter.textContent = String(activeIndex + 1).padStart(2, '0');
      story.dataset.storyInitialised = 'true';
    }

    function update() {
      frameRequested = false;
      if (!window.matchMedia(DESKTOP_QUERY).matches || window.matchMedia(REDUCED_MOTION_QUERY).matches) {
        setActive(0);
        story.style.setProperty('--story-progress', '0');
        story.style.setProperty('--story-active-progress', '0');
        return;
      }

      const storyRect = story.getBoundingClientRect();
      const storyTravel = Math.max(storyRect.height - window.innerHeight, 1);
      const storyProgress = clamp(-storyRect.top / storyTravel, 0, 1);
      const focusLine = window.innerHeight * 0.52;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      chapters.forEach((chapter, index) => {
        const rect = chapter.getBoundingClientRect();
        const centre = rect.top + rect.height / 2;
        const distance = Math.abs(centre - focusLine);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      const activeRect = chapters[nearestIndex].getBoundingClientRect();
      const activeProgress = clamp((focusLine - activeRect.top) / Math.max(activeRect.height, 1), 0, 1);
      setActive(nearestIndex);
      story.style.setProperty('--story-progress', storyProgress.toFixed(4));
      story.style.setProperty('--story-active-progress', activeProgress.toFixed(4));
      story.style.setProperty('--story-light-x', `${(72 - storyProgress * 24).toFixed(2)}%`);
      story.style.setProperty('--story-light-y', `${(18 + storyProgress * 42).toFixed(2)}%`);
    }

    function requestUpdate() {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) requestUpdate();
        });
      },
      { rootMargin: '35% 0px 35% 0px', threshold: 0 }
    );

    chapters.forEach((chapter) => observer.observe(chapter));
    returnLink?.addEventListener('click', (event) => {
      const productInfo = document.querySelector('[id^="ProductInfo-"]');
      if (!productInfo) return;
      event.preventDefault();
      productInfo.scrollIntoView({ behavior: window.matchMedia(REDUCED_MOTION_QUERY).matches ? 'auto' : 'smooth' });
    });
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    setActive(0);
    requestUpdate();
    story.dataset.storyReady = 'true';
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(initialiseStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
